module.exports = __webpack_public_path__ + "img/cog.4396b867.svg";